import PropTypes from 'prop-types';
import Icon from 'Components/Atoms/Icon/Icon';
import SnackbarCard from './SnackbarCard';
import SnackbarLayout from './SnackbarLayout';
import SnackbarContent from './SnackbarContent';

export default function SnackbarSuccess({ message }) {
    return (
        <SnackbarCard>
            <SnackbarLayout>
                <div className="shrink-0">
                    <div className="bg-success text-white size-6 rounded-full flex items-center justify-center">
                        <Icon name="check" size={12} color="currentColor" />
                    </div>
                </div>
                <SnackbarContent>
                    <div className="text-sm">{message}</div>
                </SnackbarContent>
            </SnackbarLayout>
        </SnackbarCard>
    );
}

SnackbarSuccess.propTypes = {
    message: PropTypes.string.isRequired,
};
